import { getAdminV1StoresStoreIdUploadsId } from '@nucleus-commerce/api-client/admin';

/**
 * A file a shopper attached to an order line, fetched through the API client so the session
 * cookie and client header travel with it (a plain link would be refused). The generated
 * function is typed as a string body; with `responseType: 'blob'` axios hands back a Blob.
 */
export const uploadsApi = {
  download: async (storeId: string, id: string): Promise<Blob> => {
    const body: unknown = await getAdminV1StoresStoreIdUploadsId(
      { storeId, id },
      { responseType: 'blob', headers: { Accept: '*/*' } },
    );
    if (!(body instanceof Blob)) throw new TypeError('Upload download did not return a Blob');
    return body;
  },
};
